import { Clock } from "lucide-react";
import { usePromotionCountdown } from "../hooks/usePromotionCountdown";

type Props = { endsAt: string | null };

export const PromotionCountdown = ({ endsAt }: Props) => {
  const { formatted } = usePromotionCountdown(endsAt);

  if (!formatted) return null;

  return (
    <span
      className="flex items-center gap-1 text-xs text-zinc-600"
      aria-live="polite"
    >
      <Clock size={11} strokeWidth={2} aria-hidden="true" />
      <span>
        Offre valable
        {" "}
        {formatted}
      </span>
    </span>
  );
};
